import { faKey, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useQuery } from '@tanstack/react-query';
import {
  BrandDetailSingle,
  BrandResponse,
  getBrandById
} from 'api/categories/_requests';
import { ProductReviewDetail } from 'api/products/_requests';
import {
  getAllProductByVendor,
  getVendorDetailsById,
  VendorDetailSingle
} from 'api/user/vendor_requests';
import Button from 'components/base/Button';
import Section from 'components/base/Section';
import EcoimDefaultAddressCard from 'components/cards/EcoimDefaultAddressCard';
import EcomBrandDefaultAddressCard from 'components/cards/EcomBrandDefaultAddressCard';
import EcomBrandDetailsCrad from 'components/cards/EcomBrandDetailsCrad';
import BrandDetailsTabs from 'components/modules/e-commerce/brandDetails/BrandDetailsTabs';
import { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { useParams } from 'react-router-dom';
import { RootState } from 'redux-state/store';

const BrandDetailPage = () => {
  const { slug } = useParams();
  const [countProduct, setCountProduct] = useState(0);

  const [brand, setBrand] = useState<BrandDetailSingle>({
    _id: '',
    name: '',
    image: '',
    email: '',
    phone: '',
    address: '',
    createdAt: '',
    totalRating: 0,
    totalReview: 0,
    averageRating: 0,
    totalRanking: 0
  });

  useEffect(() => {
    if (slug) {
      const fetchProduct = async () => {
        try {
          const response: BrandResponse = await getBrandById(slug);
          setBrand(response?.brand);
          setCountProduct(response?.productCount);
        } catch (error) {
          console.error('Failed to fetch vendor details:', error);
        }
      };

      fetchProduct();
    }
  }, [slug]);

  return (
    <Container className="px-xl-0 px-xxl-3 mt-5">
      <Row className="align-items-center justify-content-between g-3 mb-4">
        <Col xs="auto">
          <h2 className="mb-0">Brand Details</h2>
        </Col>
      </Row>
      <Row className="g-3 mb-6">
        <Col xs={12} lg={8}>
          <EcomBrandDetailsCrad
            brandId={brand._id}
            name={brand?.name}
            image={brand?.image}
            createdAt={brand?.createdAt}
            totalRanking={brand.totalRanking}
            productsCount={countProduct}
            totalReview={brand?.totalReview ? brand?.totalReview : 0}
          />
        </Col>
        <Col xs={12} lg={4}>
          <EcomBrandDefaultAddressCard
            address={brand?.address}
            email={brand?.email}
            phone={brand?.phone}
          />
        </Col>
      </Row>
      <BrandDetailsTabs brandSlug={slug!} />
    </Container>
  );
};

export default BrandDetailPage;
